import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AIChatMessagesData,
  AIChatService,
} from 'src/modules/features/admin/services/ai-chat';

@Component({
  selector: 'app-ai-chat-messages',
  templateUrl: './ai-chat-messages.component.html',
  styleUrls: ['./ai-chat-messages.component.scss'],
})
export class AIChatMessagesComponent implements OnInit {
  @Input() messages: AIChatMessagesData['rows'];
  @Output() message = new EventEmitter<AIChatMessagesData['rows'][0]>();

  feedbackForm: FormGroup;

  isGivingFeedback = false;
  feedbackType: 'POSITIVE' | 'NEGATIVE';
  activeChat: AIChatMessagesData['rows'][0];
  showReference = false;
  canReply$ = new Observable<boolean>();

  ngOnInit(): void {
    this.messages.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  constructor(private aiChatService: AIChatService, private fb: FormBuilder) {
    this.feedbackForm = this.fb.group({
      feedback: ['', Validators.required],
    });

    this.canReply$ = this.feedbackForm.statusChanges.pipe(
      map((status) => {
        console.log(status);
        return status === 'VALID';
      })
    );
  }

  giveFeedback(
    type: 'POSITIVE' | 'NEGATIVE',
    chat: AIChatMessagesData['rows'][0]
  ) {
    this.isGivingFeedback = true;
    this.feedbackType = type;
    this.activeChat = chat;
  }

  cancelFeedback() {
    this.isGivingFeedback = false;
    this.feedbackForm.reset();
    this.feedbackType = undefined;
  }

  ngSubmit() {
    const message = this.activeChat;
    let updatedMessage: AIChatMessagesData['rows'][0] = { ...message };
    if (this.feedbackType === 'POSITIVE') {
      updatedMessage.positiveFeedBack = 'THE RESPONSE WAS HELPFUL';
    }
    if (this.feedbackType === 'NEGATIVE') {
      updatedMessage.negativeFeedBack = 'THE RESPONSE WAS HELPFUL';
    }
    this.message.emit(updatedMessage);

    let feedback = this.feedbackForm.value.feedback;
    let type = this.feedbackType;

    this.feedbackType = undefined;
    this.isGivingFeedback = false;
    this.feedbackForm.reset();
    this.activeChat = undefined;

    this.aiChatService
      .rateChatMessage({
        feedback: feedback,
        messageId: message.id,
        feedbackType: type,
        sessionId: message.session,
      })
      .subscribe(
        (res) => {
          console.log(res);
          this.message.emit(res);
        },
        (error) => {
          updatedMessage.positiveFeedBack = null;
          this.message.emit(updatedMessage);
        }
      );
  }

  likeMessage(message: AIChatMessagesData['rows'][0]) {
    let updatedMessage: AIChatMessagesData['rows'][0] = { ...message };
    updatedMessage.positiveFeedBack = 'THE RESPONSE WAS HELPFUL';
    this.message.emit(updatedMessage);

    this.aiChatService
      .rateChatMessage({
        feedback: 'THE RESPONSE WAS HELPFUL',
        messageId: message.id,
        feedbackType: 'POSITIVE',
        sessionId: message.session,
      })
      .subscribe(
        (res) => {
          console.log(res);
          this.message.emit(res);
        },
        (error) => {
          updatedMessage.positiveFeedBack = null;
          this.message.emit(updatedMessage);
        }
      );
  }

  dislikeMessage(message: AIChatMessagesData['rows'][0]) {
    let updatedMessage: AIChatMessagesData['rows'][0] = { ...message };
    updatedMessage.negativeFeedBack = 'THE RESPONSE WAS NOT HELPFUL';
    this.message.emit(updatedMessage);

    this.aiChatService
      .rateChatMessage({
        feedback: 'THE RESPONSE WAS HELPFUL',
        messageId: message.id,
        feedbackType: 'NEGATIVE',
        sessionId: message.session,
      })
      .subscribe(
        (res) => {
          console.log(res);
          this.message.emit(res);
        },
        (error) => {
          updatedMessage.negativeFeedBack = null;
          this.message.emit(updatedMessage);
        }
      );
  }

  handleReference(message: AIChatMessagesData['rows'][0]) {
    if (message.id !== this.activeChat?.id && this.activeChat) {
      this.showReference = true;
    } else {
      this.showReference = !this.showReference;
    }

    if (this.showReference) {
      this.activeChat = message;
      return;
    }
    this.activeChat = undefined;
  }
}
